import api from "@/core/app/api";
import app from "@/core/app/app";
import acp from "@/core/app/acp";

const getLocalMysqlTimestamp = () => {
    return new Date().toLocaleString('sv-SE').replace(',', '');
};

let lastCheckTime = "";

async  function refreshCalls  () {


    const response = await api.post('shuttle/get-not-ack', {date: lastCheckTime});
    // console.log ("shuttle Refresh", response);
    if (!response || !response.ok) return;
    if (response.status===200) {
        app.setShuttleCalls(response.data);
        const newCalls = response.data.filter(item => {return item.updated > lastCheckTime;        });
        for (const call of newCalls) {
            const time = call.date.slice(11, 16);
            acp.sendToast("info",  `Shuttle        ${call.bookingId}     ${time}h`);
        }
    }


    updateLastCheckTime();
}


async  function ack (index) {
    const id = app.state.shuttleCalls[index]?.id;
    if (!id) return;
    app.removeShuttleCall(index);
    await api.post('shuttle/ack', {id: id});

}
function updateLastCheckTime() {

    lastCheckTime = getLocalMysqlTimestamp();
}
export const ShuttleCalls = {

    refresh: refreshCalls, ack
};



